module.exports = __webpack_public_path__ + "img/close_modal.cf94f2ce.svg";